import React, { FC, useState, useEffect } from 'react';
import useEEActive from '../../../hooks/useEEActive';
import { windowService } from '../../../utils/window.utils.js';
import { EventEnum } from '../../../enums/event.enum';
import Spinner from '../spinner';

const Loader: FC<{}> = () => {
  const isEEActive = useEEActive();
  const [showLoader, setShowLoader] = useState<boolean[]>([]);

  useEffect(() => {
    windowService().addEventListener(EventEnum.ADD_LOADER_QUEUE_ITEM, () => {
      setShowLoader((prev) => [...prev, true]);
    });

    windowService().addEventListener(EventEnum.REMOVE_LOADER_QUEUE_ITEM, () => {
      setShowLoader((prev) => [...prev].slice(0, -1));
    });

    return () => {
      windowService().removeEventListener(EventEnum.ADD_LOADER_QUEUE_ITEM);
      windowService().removeEventListener(EventEnum.REMOVE_LOADER_QUEUE_ITEM);
    };
  }, []);

  if (isEEActive) return null;

  return (
    <div className={`loader ${showLoader.length > 0 ? 'loader--show' : ''}`}>
      <Spinner />
    </div>
  );
};

export default Loader;
